import axios from 'axios';
import { Amenity, CreateAmenityData, UpdateAmenityData } from '../types/amenity';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';
const API_URL = `${BASE_URL}/workspaces`;

export const getAmenities = async (
  workspaceId: string,
  projectId: string
): Promise<Amenity[]> => {
  const token = localStorage.getItem('token');
  const response = await axios.get(
    `${API_URL}/${workspaceId}/projects/${projectId}/amenities`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return response.data.amenities;
};

export const getAmenityById = async (
  workspaceId: string,
  projectId: string,
  amenityId: string
): Promise<Amenity> => {
  const token = localStorage.getItem('token');
  const response = await axios.get(
    `${API_URL}/${workspaceId}/projects/${projectId}/amenities/${amenityId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return response.data.amenity;
};

export const createAmenity = async (
  workspaceId: string,
  projectId: string,
  data: CreateAmenityData
): Promise<Amenity> => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${API_URL}/${workspaceId}/projects/${projectId}/amenities`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return response.data.amenity;
};

export const updateAmenity = async (
  workspaceId: string,
  projectId: string,
  amenityId: string,
  data: Partial<CreateAmenityData>
): Promise<Amenity> => {
  const token = localStorage.getItem('token');
  const response = await axios.put(
    `${API_URL}/${workspaceId}/projects/${projectId}/amenities/${amenityId}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return response.data.amenity;
};

export const deleteAmenity = async (
  workspaceId: string,
  projectId: string,
  amenityId: string
): Promise<void> => {
  const token = localStorage.getItem('token');
  await axios.delete(
    `${API_URL}/${workspaceId}/projects/${projectId}/amenities/${amenityId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
};

export const reorderAmenities = async (
  workspaceId: string,
  projectId: string,
  amenityIds: string[]
): Promise<void> => {
  const token = localStorage.getItem('token');
  await axios.post(
    `${API_URL}/${workspaceId}/projects/${projectId}/amenities/reorder`,
    { amenityIds },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
};
